import queryString from "query-string";

import Voucher from "features/vouchers";
import Context from "shared/util/Context";
import { isDesktop, isIOS, isAndroid } from "shared/util/EnvironmentHelpers";
import isApp from "shared/util/isApp";
import { checkIsValidVoucher } from "shared/components/VoucherModal/web";
import { PlatformType, VOUCHER_CODE_KEY, VOUCHER_SET_TIME, DAY_IN_MS } from "shared/components/VoucherModal/constants";

export const typeOfPlatform = () => {
	const isNative = isApp();

	if (isDesktop) {
		return PlatformType.DESKTOP;
	} else if (isNative && isIOS) {
		return PlatformType.IOS;
	} else if (isNative && isAndroid) {
		return PlatformType.ANDROID;
	} else if (!isNative && isAndroid) {
		return PlatformType.ANDROID_WEB;
	}

	return PlatformType.MOBILE_WEB;
};

const removeVoucherKeyFromStorage = () => {
	try {
		localStorage.removeItem(VOUCHER_CODE_KEY);
		localStorage.removeItem(VOUCHER_SET_TIME);
	} catch (err) {
		console.log(err);
	}
};

export const processVoucher = (voucher) => {
	try {
		removeVoucherKeyFromStorage();
	} catch (err) {
		console.error(err);
	}

	const platform = typeOfPlatform();
	return checkIsValidVoucher({ voucher, platform });
};

export const saveVoucher = (voucher) => {
	try {
		localStorage.setItem(VOUCHER_CODE_KEY, voucher);
		localStorage.setItem(VOUCHER_SET_TIME, Date.now());
	} catch (err) {
		console.error(err);
	}
};

export const hasSavedVoucher = () => {
	try {
		const voucherSetTime = parseInt(localStorage.getItem(VOUCHER_SET_TIME), 10);

		if (!voucherSetTime) {
			return false;
		} else if (Date.now() - voucherSetTime > DAY_IN_MS) {
			removeVoucherKeyFromStorage();
		}

		return localStorage.getItem(VOUCHER_CODE_KEY);
	} catch (err) {
		return "";
	}
};

export const shouldOpenVoucherModalFromUrl = () => {
	const queryParams = queryString.parse(window.location.search);

	return queryParams.redeem_voucher || queryParams.voucher_code;
};

export const getVoucherCodeFromUrl = () => {
	const queryParams = queryString.parse(window.location.search);

	return (queryParams.voucher_code || "").toUpperCase();
};

export const voucherCheck = () => {
	// Already entered voucher.
	const hasStoredVoucher = hasSavedVoucher();
	const isLoggedIn = !!Context.get("userid");
	const isNotOnboarding = window.location && window.location.pathname !== "/onboarding";

	if (hasStoredVoucher && isLoggedIn && isNotOnboarding) {
		Voucher.open();
	}

	// Query params to open voucher modal.
	if (shouldOpenVoucherModalFromUrl()) {
		Voucher.open();
	}
};



// WEBPACK FOOTER //
// ./src/shared/components/VoucherModal/helpers.js